import React from "react";
import { useLocation } from "react-router-dom";

const Mydocview = () => {
  const location = useLocation();
  const { text } = location.state || {};

  return (
    <div className="w-100 comp v-center h-center mt-4 flex-column gap-2">
      <h4>Doc Name</h4>
      <div className="column right doc-view ">
        <h4>Anonymized Text</h4>
        <div className="blockquote">{text}</div>
      </div>
    </div>
  );
};

export default Mydocview;
